import styled from 'styled-components';

export const DialogActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;
